import { LogLevel } from "@azure/msal-browser";
import { STARK_MSAL } from "MSALAuthConfig";

const verboseLogging = false

const starkMsalConfig = {
    auth: {
        clientId: STARK_MSAL.CLIENT_ID,
        authority:STARK_MSAL.AUTHORITY,
        knownAuthorities: STARK_MSAL.KNOWN_AUTHORITY,
        redirectUri: STARK_MSAL.REDIRECT_URI,
    },
    cache: {
        cacheLocation: "localStorage",
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        if(verboseLogging){
                            console.info(message);
                        }
                        return;
                    case LogLevel.Verbose:
                        if(verboseLogging){
                            console.debug(message);
                        }
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
        allowNativeBroker: false,
    },
};

const starkImpersonationMsalConfig = {
    ...starkMsalConfig,
    auth: {
        ...starkMsalConfig.auth,
        authority: STARK_MSAL.IMPERSONATION_AUTHORITY,
        redirectUri: STARK_MSAL.IMPERSONATION_REDIRECT_URI,
    },
}

export const getMsalConfig = (brandSlug, impersonation) => {
    switch (brandSlug) {
        case 'handvaerkerklub':
            return impersonation ? starkImpersonationMsalConfig : starkMsalConfig    
        default:
            return null;
    }
}

export const getMsalScopes = (brandSlug) => {
    switch (brandSlug) {
        case 'handvaerkerklub':
            return [STARK_MSAL.CLIENT_ID, "openid", "profile", "email"]  
        default:
            return null;
    }
}